import { useForm as createUseForm } from "@ant-design-vue/use";
import { scrollToHasError } from "../../utils/scroll";

export const createForm = ({ props }) => {
    let hasValue = false;
    props.columns.map(column => {
        if (!column.search.field.searchValue) {
            if (column.search.operator === "in") {
                column.search.field.searchValue = [];
            } else {
                column.search.field.searchValue = null;
            }
        } else {
            hasValue = true;
        }
        column.search.field.columns = props.columns;
    });
    if (hasValue) {
        if (!props.dataTable.options) props.dataTable.options = {};
        if (!props.dataTable.options.search) props.dataTable.options.search = {};
        props.dataTable.options.search.activeKey = "Search";
    }
    return props.columns;
};

export const createRules = ({ props }) => {
    const rules = {};
    props.columns.map((column, index) => {
        if (!column.search.field.rulesRef) column.search.field.rulesRef = [];
        column.search.field.key = `${index}.search.field.searchValue`;
        rules[column.search.field.key] = column.search.field.rulesRef;
    });
    return rules;
};

export const createField = ({ props }) => {
    return props.columns.map(column => column.search?.field);
};

export const onClickReset = ({ props, data, emit }) => {
    Promise.resolve()
        .then(() => {
            props.columns.map(column => {
                column.search.field.searchValue = null;
            });
        })
        .then(() => data.useForm.resetFields(props.columns))
        .then(() => onClickSearch({ props, data, emit }));
};

export const onClickSearch = ({ props, data, emit }) => {
    data.useForm
        .validate()
        .then(() => {
            props.dataTable.page.page = 0;
            emit("search");
        })
        .catch(() => scrollToHasError());
};

export const init = ({ props, data, emit }) => {
    data.form = createForm({ props, data, emit });
    data.rules = createRules({ props, data, emit });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, emit });
};
